import React from 'react';

const AIProSubscriptionModal = ({ isOpen, onClose, onSubscribe }) => {
  const features = [
    {
      icon: '✍️',
      title: 'Unlimited AI leírás',
      description: 'Korlátlan AI-generált hirdetés szöveg'
    },
    {
      icon: '🎨',
      title: 'AI staging kedvezmény',
      description: '50% kedvezmény minden staging képnél'
    },
    {
      icon: '⭐',
      title: 'AI score részletes',
      description: 'Mélyreható elemzés és ajánlások'
    },
    {
      icon: '💰',
      title: 'AI price insights',
      description: 'Piaci elemzés és ároptimalizálás'
    },
    {
      icon: '📊',
      title: 'Heti riportok',
      description: 'Részletes statisztikák és trendek'
    },
    {
      icon: '🚀',
      title: 'Prioritás támogatás',
      description: 'Gyorsabb válaszidő és segítség'
    }
  ];

  const handleSubscribe = () => {
    onSubscribe({
      plan: 'ai-pro',
      price: 4990,
      period: 'monthly'
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto border-2 border-purple-500/30 shadow-2xl">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-purple-600 via-blue-600 to-cyan-600 p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center gap-2 mb-2">
                <span className="text-3xl">🤖</span>
                <h2 className="text-2xl md:text-3xl font-black text-white">
                  HOPP AI PRO
                </h2>
              </div>
              <p className="text-white/90">
                Unlimited AI funkciók + exkluzív előnyök
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white/20 rounded-full p-2 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Price */}
          <div className="bg-gradient-to-br from-purple-500/20 to-blue-500/20 backdrop-blur-xl rounded-2xl p-6 border-2 border-purple-500/30 mb-6 text-center">
            <div className="text-sm text-gray-300 mb-2">Havi előfizetés</div>
            <div className="text-5xl font-black text-white mb-2">
              4.990 Ft
            </div>
            <div className="text-gray-300 text-sm">
              / hó • Bármikor lemondható
            </div>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-xl p-4 border border-white/[0.08]"
              >
                <div className="flex items-start gap-3">
                  <div className="text-3xl">{feature.icon}</div>
                  <div>
                    <h4 className="text-white font-bold mb-1">{feature.title}</h4>
                    <p className="text-gray-300 text-sm">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Value Proposition */}
          <div className="bg-gradient-to-r from-green-500/20 to-emerald-500/20 backdrop-blur-xl rounded-xl p-6 border border-green-500/30 mb-6">
            <h3 className="text-white font-black text-lg mb-4 text-center">💰 Mennyit spórolsz?</h3>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between items-center">
                <span className="text-gray-300">AI leírás (5x használat)</span>
                <span className="text-white font-bold">~5.000 Ft</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-300">AI staging kedvezmény</span>
                <span className="text-white font-bold">~2.000 Ft</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-300">Price insights</span>
                <span className="text-white font-bold">~3.000 Ft</span>
              </div>
              <div className="border-t border-white/[0.08] pt-3 mt-3 flex justify-between items-center">
                <span className="text-white font-bold">Összesen érték:</span>
                <span className="text-green-400 font-black text-xl">~10.000 Ft</span>
              </div>
            </div>
          </div>

          {/* Comparison */}
          <div className="bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-xl rounded-xl p-6 border border-blue-500/30 mb-6">
            <h3 className="text-white font-black text-lg mb-4">📊 FREE vs PRO</h3>
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-gray-300 text-sm">AI leírás</span>
                <div className="flex gap-4">
                  <span className="text-gray-400 text-sm">3 / hó</span>
                  <span className="text-green-400 font-bold text-sm">Unlimited</span>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-300 text-sm">AI staging</span>
                <div className="flex gap-4">
                  <span className="text-gray-400 text-sm">Teljes ár</span>
                  <span className="text-green-400 font-bold text-sm">-50%</span>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-300 text-sm">Price insights</span>
                <div className="flex gap-4">
                  <span className="text-gray-400 text-sm">Alap</span>
                  <span className="text-green-400 font-bold text-sm">Részletes</span>
                </div>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/[0.08] mb-6">
            <div className="flex gap-1 mb-3">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="text-yellow-400 text-xl">⭐</span>
              ))}
            </div>
            <p className="text-gray-300 italic mb-3">
              "Az AI PRO-val havonta 3-4 hirdetést optimalizálok. Már az első hónapban megtérült!"
            </p>
            <div className="flex items-center gap-3">
              <div className="text-2xl">👨‍💼</div>
              <div>
                <div className="text-white font-bold">Nagy Péter</div>
                <div className="text-gray-400 text-sm">Ingatlanbefektető</div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="flex-1 bg-white/10 hover:bg-white/20 text-white font-bold py-4 rounded-xl transition-colors border-2 border-white/[0.08]"
            >
              Most nem
            </button>
            <button
              onClick={handleSubscribe}
              className="flex-1 bg-gradient-to-r from-purple-600 via-blue-600 to-cyan-600 hover:from-cyan-600 hover:to-purple-600 text-white font-black py-4 rounded-xl shadow-xl hover:shadow-2xl hover:shadow-purple-500/50 transition-all"
            >
              Előfizetek most! 🤖
            </button>
          </div>

          {/* Guarantee */}
          <div className="text-center mt-4">
            <p className="text-gray-400 text-sm">
              ✓ Bármikor lemondható • ✓ Első 7 nap ingyenes próba
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIProSubscriptionModal;
